import { useState } from "react";
import { handleError, sliceText } from "utils";
import constants from "../../constants";
import {
  getDefaultProfileImage,
  getOtherChannelMembers,
  getOtherSendbirdMembers,
  parseChannelMembers,
  resolveMessengerGroupMemberCount,
} from "./channelData.helpers";

const useConversationHeaderState = (dependencies) => {
  const { t, channel, currentUser, externalTabActive, sdk, setCurrentChannel } =
    dependencies;

  const [isPopOpen, setIsPopOpen] = useState(false);
  const [isConversationStateLoading, setIsConversationStateLoading] =
    useState(false);
  const isConversationClosed =
    channel?.customType === constants.chat.patient.close;
  const getChannelData = () => {
    try {
      if (!channel) return {};
      const { name: groupName, coverUrl, memberCount, members, data } = channel;

      let channelName = groupName;
      let officeName = "";
      let officeId = "";
      let id = "";
      let profilePic = coverUrl || getDefaultProfileImage();
      let subTitle = externalTabActive
        ? t("messenger.externalChat")
        : t("messenger.internalChat");

      const customMembers = parseChannelMembers(data);
      const resolvedMemberCount = resolveMessengerGroupMemberCount(
        memberCount,
        members,
        customMembers,
      );

      if (data && resolvedMemberCount === 2) {
        const otherCustomUser = getOtherChannelMembers(
          customMembers,
          currentUser?.id,
        )?.[0];
        const otherSendbirdMember = getOtherSendbirdMembers(
          members,
          currentUser?.id,
        )?.[0];
        // Do not show peer office under the name in the open chat header (all 1:1).
        officeName = "";
        channelName = externalTabActive
          ? channelName
          : otherSendbirdMember?.nickname || otherCustomUser?.name || groupName;
        profilePic = otherSendbirdMember?.plainProfileUrl || getDefaultProfileImage();
        subTitle = !externalTabActive ? "" : subTitle;
        id = otherCustomUser?.id;
        officeId = otherCustomUser?.officeId;
      }
      return {
        officeName,
        channelName: sliceText(channelName, 40),
        channelImage: profilePic,
        subTitle,
        id,
        officeId,
      };
    } catch {
      return {};
    }
  };

  const toggleChat = async (channelUrl, customType) => {
    if (!channelUrl) {
      return;
    }
    setIsConversationStateLoading(true);
    try {
      const getgrpChannel = await sdk.groupChannel.getChannel(channelUrl);
      const updateChannel = await getgrpChannel.updateChannel({
        customType: customType,
      });
      setIsPopOpen(false);
      if (updateChannel) {
        setCurrentChannel(updateChannel);
      }
      return updateChannel;
    } catch (error) {
      handleError(error);
    } finally {
      setIsConversationStateLoading(false);
    }
  };

  const toggleChatOpenState = async () => {
    try {
      if (isConversationClosed) {
        return await toggleChat(channel._url, constants.chat.patient.open);
      }
      return await toggleChat(channel._url, constants.chat.patient.close);
    } catch (error) {
      handleError(error);
    }
  };

  return {
    state: {
      isConversationClosed,
      isPopOpen,
      isConversationStateLoading,
    },
    updateMethods: {},
    otherMethods: {
      getChannelData,
      toggleChatOpenState,
      setIsPopOpen,
    },
  };
};

export default useConversationHeaderState;
